import { createFileRoute } from "@tanstack/react-router";
import { AcoesConfigurarPage } from "@/paginas/pg_acoes/acoes-configurar";

export const Route = createFileRoute("/_authenticated/acoes-configurar")({
  component: AcoesConfigurarPage,
});
